import React from 'react';
import { messageFormat } from '@clubmed/utils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductMustTryLarge } from 'Components/widgets/product-must-try/ProductMustTryLarge';
import { ProductMustTryNarrow } from 'Components/widgets/product-must-try/ProductMustTryNarrow';
type Props = {
  config: CMSContent;
  id: string;
  isFrench?: boolean;
  mustTryExperiences: Array<{
    description: string;
    id: string;
    image: string;
    title: string;
  }>;
  resort: Product;
  seeMore: string;
  title: string;
};
export const ProductMustTryLine = ({
  config: { common: { scrollBackward, scrollForward } = {} } = {},
  id,
  isFrench,
  mustTryExperiences,
  resort,
  seeMore,
  title = '',
}: Props) => {
  const { isTablet } = useResponsive();
  const track = useTracking();
  const items = (mustTryExperiences || []).map(
    ({ id: itemId, title: itemTitle, image, description }) => ({
      description,
      id: itemId,
      imageSrc: image,
      onClick: (isExpanded) => {
        if (!isExpanded) {
          track({
            categoryGA: 'cards',
            actionGA: 'must_try',
            labelGA: itemTitle,
          });
        }
      },
      seeMoreLabel: seeMore,
      title: itemTitle,
    }),
  );

  if (!resort || !items.length) {
    return null;
  }

  const { color: productColor, name: productName, icon: productIconName } = resort;
  const props = {
    isFrench,
    items,
    productColor,
    productIconName,
  };
  const titleNode = (
    <LineTitle>
      {messageFormat(title).format({
        productName,
      })}
    </LineTitle>
  );
  return isTablet ? (
    <SiteContainer className="Line" id={id}>
      {titleNode}
      <ProductMustTryLarge {...props} />
    </SiteContainer>
  ) : (
    <div
      {...(id
        ? {
            id,
          }
        : null)}
      className="Line"
    >
      <SiteContainer>{titleNode}</SiteContainer>
      <ProductMustTryNarrow
        {...props}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
      />
    </div>
  );
};
